module.exports = __webpack_public_path__ + "b8960026c914d2359fc356b355229553.svg";